import { BaseType } from '../base/base-type';
import { TaxResidencyTypeIdEnum } from './tax-residency-type-id.enum';

export class TaxResidencyType extends BaseType {
  public declare id: TaxResidencyTypeIdEnum;
}
